import { SectionEnum } from "../enums/SectionEnum";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { ActiveTabEnum } from "../enums/ActiveTabEnum";
import { getUserFullName } from "../../../common/utils/getUserFullName";

interface Props {
    section: {
        name: "required" | "achieved";
        value: number;
    };
    activeTab: string;
    employeeData: EmployeeInterface;
}

export const getEmptyResult = (
    props: Props,
): { text: string; showButton: boolean } => {
    const { section, activeTab, employeeData } = props;
    const hasFunctionGroup = employeeData.function_groups.length > 0;

    if (section.name === SectionEnum.REQUIRED) {
        return {
            text: hasFunctionGroup
                ? `${getUserFullName(employeeData.user)} heeft alle kwalificaties al behaald.`
                : `${getUserFullName(employeeData.user)} heeft nog geen functiegroep.`,
            showButton: false,
        };
    }

    if (section.name === SectionEnum.ACHIEVED) {
        return activeTab === ActiveTabEnum.ACTIVE
            ? {
                  text: `${getUserFullName(employeeData.user)} heeft nog geen certificaten behaald.`,
                  showButton: true,
              }
            : {
                  text: `${getUserFullName(employeeData.user)} heeft nog geen verlopen certificaten.`,
                  showButton: false,
              };
    }

    return {
        text: "",
        showButton: false,
    };
};
